// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"bb242a15","81":"f0988de2","199":"e3a5cf87","239":"3a6de793","488":"07408dd9","875":"07e424e1"}[chunkId] + ".chunk.js";
};